import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { Assets } from "../../../assets";
import { DatePicker, Form, Input, InputNumber, Switch } from "antd";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { useEffect, useState } from "react";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { useNavigate, useParams } from "react-router";
import { DynamicUploadImage } from "../../../common/components/Upload/DynamicUploadImage";
import { SimpleInput } from "../../../common/components/simpleInput";
import style from "./style.module.scss";
import { FormatDate } from "../../../utilities/formatDate";
import { Loader } from "../../../common/components/Loader/Loader";
import { StaffService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { InputSelect } from "../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../utilities/API_URLs";

export const AddStaff = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isShowPasswordInput, setIsShowPasswordInput] =
    useState<boolean>(false);

  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(
    null
  );
  const [isUserInitialValue, setIsUserInitialValue] = useState<boolean>(false);

  useEffect(() => {
    id && getStaff(+id);
  }, [id]);

  const getStaff = async (id: number) => {
    try {
      setIsLoading(true);

      const res = await StaffService.getOneStaff(id);
      if (res?.status === HttpStatusCode.Ok) {
        setIsShowPasswordInput(res?.data?.isShow);
        setSelectedDepartment(res?.data?.departmentType?.id);
        setIsUserInitialValue(res?.data?.isShow);
        const formatedData = {
          ...res?.data,
          image: res?.data?.image
            ? {
                value: res?.data?.image?.["@id"],
                label: res?.data?.image?.basename,
                url: res?.data?.image?.contentUrl,
              }
            : null,
          hiringDate: res?.data?.hiringDate
            ? FormatDate.dayjsFormat(res?.data?.hiringDate)
            : null,
          departmentType: res?.data?.departmentType
            ? {
                label: res?.data?.departmentType?.name,
                value: res?.data?.departmentType?.["@id"],
              }
            : null,
          staffPost: res?.data?.staffPost
            ? res?.data?.staffPost?.map((staff: any) => ({
                label: staff?.name,
                value: staff?.["@id"],
              }))
            : [],
        };

        form.setFieldsValue(formatedData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const formatedData = {
        ...values,
        hiringDate: values?.hiringDate
          ? FormatDate.formatDateToPostEn(values?.hiringDate)
          : null,
        image: values?.image?.value ? values?.image?.value : null,
        phoneNumber: values?.phoneNumber
          ? values?.phoneNumber?.toString()
          : null,
        departmentType: values?.departmentType
          ? values?.departmentType?.value
          : null,
        staffPost: values?.staffPost.length
          ? values?.staffPost?.map((staff: any) => staff?.value ?? staff)
          : null,
        isShow: isShowPasswordInput,
      };

      if (!values?.id) {
        const res = await StaffService.createStaff(formatedData);
        console.log(res);

        if (res?.status === HttpStatusCode.Created) {
          navigate(-1);
        }
      } else {
        const res = await StaffService.updateStaff(formatedData);
        console.log(res);

        if (res?.status === HttpStatusCode.Ok) {
          navigate(-1);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        isSHowBack
        title=""
        subTitle={`Gestion Employés > ${id ? "Modification" : "Nouveau"}`}
      />

      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="bg-white  rounded-4">
          <div style={{ position: "relative" }}>
            <div className="head-of-form">
              <img
                src={Assets.images.headForm}
                alt="rect"
                className="head-form"
              />
            </div>
          </div>
          <div className="d-none">
            {id && <SimpleInput Form={Form} name="id" />}
          </div>
          <div style={{ position: "relative", top: "-52px" }}>
            <div className="px-3">
              <SimpleInput
                Form={Form}
                name="image"
                customInput={<DynamicUploadImage name="image" form={form} />}
              />
            </div>

            <div className={style.staff__container}>
              {/* Content */}
              <div className={style.staff__content}>
                <p className={style.staff__title}>Informations personnelles</p>
                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Nom"
                      name="lastname"
                      rules={[
                        {
                          required: true,
                          message: `Ce champ est requis`,
                        },
                      ]}
                    />
                  </div>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Prénom(s)"
                      name="firstname"
                      rules={[
                        {
                          required: true,
                          message: `Ce champ est requis`,
                        },
                      ]}
                    />
                  </div>
                </div>

                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput Form={Form} label="Adresse" name="address" />
                  </div>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Email"
                      name="email"
                      rules={[
                        {
                          type: "email",
                          message: `Veuillez saisir un email valide`,
                        },
                        {
                          required: true,
                          message: `Ce champ est requis`,
                        },
                      ]}
                    />
                  </div>
                </div>

                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="N° Tel"
                      name="phoneNumber"
                      // customInput={<Input className="w-100" />}
                    />
                  </div>
                  <div className={style.staff__form_item}></div>
                </div>
              </div>

              <div className={style.staff__content}>
                <p className={style.staff__title}>
                  Informations administratives
                </p>

                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Matricule"
                      name="registrationNumber"
                      rules={[
                        {
                          required: true,
                          message: `Ce champ est requis`,
                        },
                      ]}
                    />
                  </div>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Date d'embauche"
                      name="hiringDate"
                      customInput={
                        <DatePicker
                          placeholder=""
                          className="w-100"
                          format={"DD/MM/YYYY"}
                        />
                      }
                    />
                  </div>
                </div>

                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Département"
                      name={"departmentType"}
                      rules={[
                        {
                          required: true,
                          message: `Ce champ est requis`,
                        },
                      ]}
                      customInput={
                        <InputSelect
                          uri={API_URLs.staff.departmentSelect}
                          onChange={(e) => {
                            setSelectedDepartment(e?.key);
                            form.setFieldValue("staffPost", []);
                          }}
                        />
                      }
                    />
                  </div>
                  <div className={style.staff__form_item}>
                    {selectedDepartment ? (
                      <SimpleInput
                        Form={Form}
                        label="Poste"
                        name={"staffPost"}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: `Ce champ est requis`,
                        //   },
                        // ]}
                        customInput={
                          <InputSelect
                            uri={`${API_URLs.staffPost.getStaffPostSelect}`}
                            disabled={!selectedDepartment}
                            mode="multiple"
                            params={{
                              departmentType: selectedDepartment,
                            }}
                            onChange={(e) => {
                              console.log(e);

                              // setSelectedContainerState(e?.value);
                              // console.log("Selected filling status:", e?.value);
                            }}
                          />
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className={style.staff__form_item_wrapper}>
                  <div className={style.staff__form_item}>
                    <SimpleInput
                      Form={Form}
                      label="Créer utilisateur"
                      name="isShow"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: `Ce champ est requis`,
                      //   },
                      // ]}
                      customInput={
                        <Switch
                          checkedChildren="OUI"
                          unCheckedChildren="NON"
                          onChange={setIsShowPasswordInput}
                        />
                      }
                    />
                  </div>
                  {isShowPasswordInput && (
                    <>
                      <div className={style.staff__form_item}>
                        <SimpleInput
                          Form={Form}
                          label="Mot de passe"
                          name="plainPassword"
                          rules={[
                            {
                              required:
                                !isUserInitialValue && isShowPasswordInput
                                  ? true
                                  : false,
                              message: `Ce champ est requis`,
                            },
                          ]}
                          customInput={
                            <Input.Password
                              autoComplete="new-password"
                              //placeholder="Saisir un mot de passe"
                            />
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center justify-content-end gap-2">
                <CustomButton
                  type="button"
                  variant="secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(-1);
                  }}
                >
                  Retour
                </CustomButton>
                <CustomButton
                  type="submit"
                  variant="primary"
                  isLoading={isLoadingSubmit}
                >
                  {"Enregistrer"}
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </FormProvider>
    </div>
  );
};
